import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { map } from 'rxjs/operators';
import { FilterTypeEnum } from '../../_common/enums/filter.enum';
import { QueueStatusListResponse, QueueStatusModel } from './queue-status.model';
import { QueueStatusService } from './queue-status.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiMethodEnum, StatusEnum } from './queue-status.enum';
import { DashCasePipe } from 'src/app/_common/pipes/dash-case-pipe';
import { PAGE_SIZE_DEFAULT, PAGE_SIZE_OPTIONS } from 'src/app/_common/constants';


@Component({
  selector: 'app-queue-status',
  templateUrl: './queue-status.component.html',
  styleUrls: ['./queue-status.component.scss']
})
export class QueueStatusComponent implements OnInit {

  queueStatuses!: MatTableDataSource<QueueStatusModel>;

  pageEvent!: PageEvent;
  
  pageIndex: number = 0;
  pageSize: number = PAGE_SIZE_DEFAULT;
  pageSizeOptions: number[] = PAGE_SIZE_OPTIONS;

  sortDirection: SortDirection = 'asc';
  sortColumn: string = 'printerNo';

  items: QueueStatusModel[] = [];
  totalRows!: number;
  columns: any[] = [
    {
      name: 'shopNumber',
      filter: {
        type: FilterTypeEnum.Text,
        name: 'filter-shopNumber'
      }
    },
    {
      name: 'method',
      filter: {
        type: FilterTypeEnum.Select,
        name: 'filter-method',
        options:
          [{ name: '', value: null }].concat(
            Object.keys(ApiMethodEnum)
                  .filter(key => isNaN(Number(key)) && ApiMethodEnum[key] > 0)
                  .map(
                    key =>  ({ name: key, 
                               value: ApiMethodEnum[key]
                            })
                  ))
      }
    },
    {
      name: 'status',
      filter: {
        type: FilterTypeEnum.Select,
        name: 'filter-status',
        options:
          [{ name: '', value: null }].concat(
            Object.keys(StatusEnum)
                  .filter(key => isNaN(Number(key)) && StatusEnum[key] > 0)
                  .map(
                    key =>  ({ name: 'reports.queues-status.' + this.dashcasePipe.transform(key), 
                               value: StatusEnum[key]
                            })
                  ))
      }
    },
    {
      name: 'quantity',
      filter: {
        type: FilterTypeEnum.None,
        name: 'filter-quantity'
      }
    }
  ];

  displayedColumns: any[] = this.columns.map(x => x.name);
  filterColumns: any[] = this.columns.map(x => x.filter).map(x => x.name);
  filter: any = {};
  filterTypes: typeof FilterTypeEnum = FilterTypeEnum;
  apiMethodEnum: typeof ApiMethodEnum = ApiMethodEnum;
  statusEnum: typeof StatusEnum = StatusEnum;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private queueStatusesService: QueueStatusService,
    public dialog: MatDialog,
    public router: Router,
    private dashcasePipe: DashCasePipe) { }

  ngOnInit(): void {
    this.loadData();
  }

  onPaginateChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadData();
  }

  onSortData(event: Sort) {
    this.sortDirection = event.direction;
    this.sortColumn = event.active;
    this.pageIndex = 0;
    this.loadData();
  }

  loadData() {
    this.queueStatusesService
      .getQueueStatuses(this.pageIndex, this.pageSize, this.sortColumn, this.sortDirection, this.filter)
      .pipe(map((res: QueueStatusListResponse) => {
        this.items = res.model;
        this.totalRows = res.totalRows;
      }))
      .subscribe();
  }

  filterData(filter: any) {
    this.filter = filter;
    this.pageIndex = 0;
    this.loadData();
  }

}
